import { takeEvery, put, call } from "redux-saga/effects";
import {
  getFoodProductList,
  setFoodProductList,
  addFoodProductToList,
  addFoodProductToListSuccess,
  addFoodProductToListFailure,
  deleteFoodProduct,
  deleteFoodProductSuccess,
  deleteFoodProductFailure,
  editFoodProduct,
  editFoodProductSuccess,
  editFoodProductFailure
} from "../actions/foodProductListAction";
import { getFoodProductListRequest } from "../../api/foodProductList/getFoodProductListRequest";
import { addFoodProductToListRequest } from "../../api/foodProductList/addFoodProductToListRequest";
import { message } from "antd";
import { deleteFoodProductRequest } from "../../api/foodProductList/deleteFoodProductRequest";
import { editFoodProductRequest } from "../../api/foodProductList/editFoodProductRequest";

function* getFoodProductListSaga(action) {
  try {
    const orderId = action.payload.orderId;
    const pagination = action.payload.pagination;
    const sort = action.payload.sort;
    const response = yield call(
      getFoodProductListRequest,
      orderId,
      pagination,
      sort
    );
    if (response.status === 200) {
      yield put(setFoodProductList(response.data));
    }
  } catch (e) {
    console.log(e);
  }
}

function* addFoodProductToListSaga(action) {
  try {
    const orderId = action.payload.orderId;
    const response = yield call(
      addFoodProductToListRequest,
      orderId,
      action.payload
    );
    if (response.status === 201) {
      yield put(addFoodProductToListSuccess());
      // В случае удачного добавления персоны - запрашиваем обновленный список персон
      const list = yield call(getFoodProductListRequest, orderId);
      if (list.status === 200) {
        yield put(setFoodProductList(list.data));
      }
    }
  } catch (e) {
    const { errors } = e && e.response && e.response.data;
    const errorMessage =
      e && e.response && e.response.data && e.response.data.message;
    message.error(errorMessage);
    yield put(addFoodProductToListFailure({ message: errorMessage, errors }));
  }
}

function* deleteFoodProductSaga(action) {
  try {
    const { orderId, foodProductId } = action.payload;
    const response = yield call(
      deleteFoodProductRequest,
      orderId,
      foodProductId
    );
    if (response.status === 200) {
      yield put(deleteFoodProductSuccess());

      // В случае удачного удаления персоны - запрашиваем обновленный список персон
      const list = yield call(getFoodProductListRequest, orderId);
      if (list.status === 200) {
        yield put(setFoodProductList(list.data));
      }
    }
  } catch (e) {
    const { errors } = e && e.response && e.response.data;
    const errorMessage =
      e && e.response && e.response.data && e.response.data.message;
    message.error(errorMessage);
    yield put(deleteFoodProductFailure({ message: errorMessage, errors }));
  }
}

function* editFoodProductSaga(action) {
  try {
    const { orderId, foodProductId } = action.payload;
    const response = yield call(
      editFoodProductRequest,
      orderId,
      foodProductId,
      action.payload
    );
    if (response.status === 200) {
      yield put(editFoodProductSuccess());

      // В случае удачного редактирования персоны - запрашиваем обновленный список персон
      const list = yield call(getFoodProductListRequest, orderId);
      if (list.status === 200) {
        yield put(setFoodProductList(list.data));
      }
    }
  } catch (e) {
    const { errors } = e && e.response && e.response.data;
    const errorMessage =
      e && e.response && e.response.data && e.response.data.message;
    message.error(errorMessage);
    yield put(editFoodProductFailure({ message: errorMessage, errors }));
  }
}

export function* orderFoodProductWatcher() {
  yield takeEvery(getFoodProductList.toString(), getFoodProductListSaga);
  yield takeEvery(addFoodProductToList.toString(), addFoodProductToListSaga);
  yield takeEvery(deleteFoodProduct.toString(), deleteFoodProductSaga);
  yield takeEvery(editFoodProduct.toString(), editFoodProductSaga);
}
